export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <span className="text-xl font-heading text-primary-400">刃牙漫画</span>
            <p className="text-sm text-white/50 leading-relaxed mt-3">
              刃牙漫画在线观看平台，提供刃牙漫画免费在线阅读与下拉式全集在线看服务。无需下载，流畅浏览全部章节。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading text-white/90 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              <a href="#cards" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">独家专题</a>
              <a href="#carousel" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">焦点推荐</a>
              <a href="#ranking" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">人气排行</a>
              <a href="#faq" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">阅读帮助</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading text-white/90 mb-4">热门篇章</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-white/50 whitespace-nowrap">刃牙道</span>
              <span className="text-sm text-white/50 whitespace-nowrap">范马刃牙</span>
              <span className="text-sm text-white/50 whitespace-nowrap">地下竞技场</span>
              <span className="text-sm text-white/50 whitespace-nowrap">中国大擂台</span>
              <span className="text-sm text-white/50 whitespace-nowrap">刃牙外传合集</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading text-white/90 mb-4">合作伙伴</h4>
            <p className="text-sm text-white/40 leading-relaxed">
              暂无具体合作站点信息，欢迎优质漫画平台联系我们洽谈合作。
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 md:mt-12 pt-6 md:pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; 2019 - 2026 刃牙漫画在线观看. 本站内容仅供学习交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-white/30 whitespace-nowrap">刃牙漫画免费在线阅读</span>
          </div>
        </div>
      </div>
    </footer>
  );
}